module.exports = __webpack_public_path__ + "static/media/lets_go_tokyo_the_west_live.9ff4d2f7.png";